import { FC, Fragment } from 'react';
import HelpTile, { TileContent } from 'features/dashboard/helpTile';

const HelpTileContainer: FC<{ closeHelp: () => void }> = ({ closeHelp }) => {
  const helpTileContents = [
    {
      title: 'Setup Instructions',
      message:
        'To get started please follow the setup instructions in our documentation guide',
      linkDetails: {
        buttonTitle: 'Setup Guide',
        path: '',
        href: 'https://ruler-documentation.readme.io/docs/introduction'
      }
    },
    {
      title: 'How to use Ruler',
      message:
        'You can find more information about how to use Ruler in our Help Centre',
      linkDetails: {
        buttonTitle: 'Help Centre',
        path: '',
        href: 'https://ruler-documentation.readme.io/docs/introduction'
      }
    },
    {
      title: 'Site Setup & Integrations',
      message:
        'Visit the Settings cog in the top right corner for Site Setup & Integrations',
      linkDetails: {
        buttonTitle: 'Settings',
        path: '/site-setup',
        href: ''
      }
    },
    {
      title: 'Further help?',
      message:
        'If you need any further help please contact us or use the Live Chat',
      linkDetails: {
        buttonTitle: 'Contact Us',
        path: '',
        href: 'https://www.ruleranalytics.com/contact/'
      }
    }
  ] as TileContent[];

  return (
    <>
      <article className="bg-primary-300 mb-5 p-7 rounded relative">
        <img
          src="/media/misc/help-bg.svg"
          alt="Help"
          className="absolute right-0 bottom-0"
        />
        <div className="flex justify-between">
          <p className=" text-2xl text-white font-medium">
            Welcome to Ruler - Getting Started
          </p>
          <button className="z-10" onClick={() => closeHelp()}>
            <i className={`ra-icons-generic-close-1 text-white text-lg`}></i>
          </button>
        </div>

        <div className="mt-7 grid grid-cols-1 lg:grid-cols-4 gap-6 relative">
          {helpTileContents.map((item: TileContent, index: number) => {
            return (
              <Fragment key={`home-help-tile-${index}`}>
                <HelpTile helpTile={item} />
              </Fragment>
            );
          })}
        </div>
      </article>
    </>
  );
};

export default HelpTileContainer;
